// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Timer-cls1___acb9ff3e1dc8f6a1c60{/*!*/}.Timer-cls2___2bea0084c0cbb4c628b{display:grid;grid-gap:3px 13px;gap:3px 13px;grid-template-columns:repeat(3, auto);justify-content:center;padding-top:16px}.Timer-cls2___2bea0084c0cbb4c628b.Timer-withoutHours___567829254e8fb6725f4{grid-template-columns:repeat(2, auto)}.Timer-cls2___2bea0084c0cbb4c628b.Timer-mini___7b9086a4f517f0b088a{grid-gap:3px 8px;gap:3px 8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Timer-cls1___acb9ff3e1dc8f6a1c60",
	"cls2": "Timer-cls2___2bea0084c0cbb4c628b Timer-cls1___acb9ff3e1dc8f6a1c60",
	"withoutHours": "Timer-withoutHours___567829254e8fb6725f4",
	"mini": "Timer-mini___7b9086a4f517f0b088a"
};
export default ___CSS_LOADER_EXPORT___;
